import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import { 
  selectCmsShareholderGroupUserPage,
  deleteShareholderGroupUser,
  addShareholderGroupUser
} from "./servers";
import { appUserBaseList } from "@/api/index";
import { Button, message, Modal, Space, Input } from "antd";
import { setIcons } from "@/utils/common";
import dayjs from "dayjs";

const UserList = () => {
  const params = useParams();
  const navigate = useNavigate();
  const groupId = params.id;
  const groupName = params.groupName;
  
  const [pageData, setPageData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState<any>({});
  const [userList, setUserList] = useState<any[]>([]);

  const [formData, setFormData] = useState<any>({
    mobile: "",
    userBusinessId: "",
    ypageNum: 1,
    ypageSize: 10,
  });

  useEffect(() => {
    if (groupId) {
      getPageData();
    }
  }, [formData, groupId]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await selectCmsShareholderGroupUserPage({
        ...formData,
        groupId: Number(groupId),
      });
      setPageData(data.rows || []);
      setTotal(data.total || 0);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const formTab = [
    {
      label: "用户ID",
      name: "userBusinessId",
      type: "input",
    },
    {
      label: "用户账号",
      name: "mobile",
      type: "input",
    },
  ];

  const getUserList = async (val: string) => {
    const res = await appUserBaseList({ mobile: val });
    setUserList(
      res.data.map((item: any) => ({
        label: `${item.nickName}（${item.mobile}）`,
        value: item.userId,
      }))
    );
  };

  const modalFormTab = [
    {
      label: "用户",
      name: "userId",
      type: "select",
      options: userList,
      width: "320px",
      rules: [{ required: true, message: "请选择用户" }],
      params: {
        showSearch: true,
        placeholder: "请输入手机号搜索",
        onSearch: getUserList,
        filterOption: false,
      },
    },
  ];

  const footer = [
    {
      title: "添加用户",
      icon: setIcons("PlusOutlined"),
      onClick: () => {
        setModalFormData({});
        setOpen(true);
      },
    },
  ];

  const columns = [
    {
      title: "用户ID",
      dataIndex: "userBusinessId",
      key: "userBusinessId",
    },
    {
      title: "昵称",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "账号",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "用户等级",
      dataIndex: "userLevel",
      key: "userLevel",
    },
    // {
    //   title: "添加时间",
    //   dataIndex: "createTime",
    //   key: "createTime",
    //   render: (time: any) => {
    //     if (!time) return '-';
    //     return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    //   },
    // },
    {
      title: "操作",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: "80px",
      render: (val: number, rows: any) => (
        <Space>
          <Button
            size="small"
            icon={setIcons("DeleteOutlined")}
            type="text"
            // danger
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(val);
            }}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  const search = (val: any) => {
    setFormData({ ...formData, ...val, ypageNum: 1 });
  };

  const reset = () => {
    setFormData({
      mobile: "",
      userBusinessId: "",
      ypageNum: 1,
      ypageSize: 10,
    });
  };

  const resetModal = () => {
    setModalFormData({});
    setOpen(false);
    setUserList([]);
  };

  const confirmSubmit = async (val: any) => {
    try {
      await addShareholderGroupUser({
        groupId: String(groupId),
        userId: String(val.userId),
      });
      message.success("添加成功");
      resetModal();
      getPageData();
    } catch (error) {}
  };

  const handleDelete = (id: number) => {
    Modal.confirm({
      title: "提示",
      content: "确定要删除该用户吗？",
      onOk: async () => {
        try {
          await deleteShareholderGroupUser(id);
          message.success("删除成功");
          getPageData();
        } catch (error) {}
      },
    });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  return (
    <div>
      <Modal
        destroyOnClose
        open={open}
        title="添加用户"
        width="400px"
        footer={<></>}
        onCancel={resetModal}
      >
        <PageTab
          subFoot
          search={confirmSubmit}
          reset={resetModal}
          formTab={modalFormTab}
          initialValues={modalFormData}
        ></PageTab>
      </Modal>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="id"
        columns={columns}
        data={pageData}
        pagination={{
          current: formData.ypageNum,
          pageSize: formData.ypageSize,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};

export default UserList;

